import { Outlet } from 'react-router-dom';
// @mui
import { Box, Stack } from '@mui/material';
// components
//
import MainSimpleFooter from './MainSimpleFooter';
import MainSimpleHeader from './MainSimpleHeader';

// ----------------------------------------------------------------------

export default function MainSimpleLayout() {
  return (
    <Stack sx={{ minHeight: 1 }}>
      <MainSimpleHeader />
      <Outlet />
      <Box sx={{ flexGrow: 1 }} />
      <MainSimpleFooter />
    </Stack>
  );
}
